.actions {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 0.5rem;
}

.play {
  width: 30px;
  height: 30px;
}

.external {
  font-size: var(--font-size-body-2);
}

.current {
  color: var(--primary);
}

.dim {
  color: var(--gray-700);
}

.mention {
  padding: 0.25rem 0;
  cursor: pointer;

  & + & {
    border-top: 1px solid var(--gray-300);
  }
}
